<template>
  <DialogContainer show class="notice-mask" @close="cancelNotification">
    <div ref="noticeModal" class="notice-modal">
      <div class="notice-top">
        <div class="cancel-btn" @click="cancelNotification">{{ $t('owork_base.close') }}</div>
        <div class="notice-title">{{ $t('owork_base.notice') }}</div>
        <span v-if="noticeDatas.length" class="notice-button" @click="removeAllNotices">{{
          $t('owork_base.clear_all')
        }}</span>
      </div>
      <div v-if="noticeDatas.length" class="notice-container">
        <NoticeList :notice-data="noticeDatas" :on-action-button-click="cancelNotification" />
      </div>
      <div v-else class="notice-tips">
        <img class="notice-img" src="@assets/svgs/bg-notification-list-empty.svg" alt="" />
        <div class="no-notice">{{ $t('owork_base.no_notice') }}</div>
      </div>
    </div>
  </DialogContainer>
</template>

<script lang="ts" setup>
  import { ref, onMounted, onBeforeUnmount } from 'vue'
  import DialogContainer from '../dialog/DialogContainer.vue'
  import NoticeList from './NoticeList.vue'
  import type { NoticeDataType } from '@/core/Notification/NotificationManager'
  import { INSTANCE as NotificationManager } from '@/core/Notification/NotificationManager'
  import { MainHeaderItems, useSharedActiveMainHeaderItem } from '@/core/compositions/ActiveMainHeaderItem'
  import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock-upgrade'
  import { useSharedScreen } from '@/core/compositions/Screen'

  const { isStandardScreen } = useSharedScreen()
  const { updateCurrentSelectedItem } = useSharedActiveMainHeaderItem()

  const noticeDatas = ref<NoticeDataType[]>([])
  const noticeModal = ref<HTMLElement>()

  const refreshList = () => {
    noticeDatas.value = [...NotificationManager.getNoticeList()]
  }

  // 子组件点击查看关闭  关闭通知中心
  const cancelNotification = () => {
    updateCurrentSelectedItem(MainHeaderItems.NOTIFICATION_CENTER)
  }

  onMounted(() => {
    NotificationManager.markAllNoticeAsRead()
    refreshList()

    NotificationManager.addNoticeListener({
      onAdded: () => {
        refreshList()
      },
      onUpdated: () => {
        refreshList()
      },
      onRemoved: () => {
        refreshList()
      },
      onMarkAsRead() {
        refreshList()
      },
      onRemoveAll() {
        refreshList()
      },
      onDismiss() {
        refreshList()
      },
    })

    if (!isStandardScreen.value && noticeModal.value) {
      // disableBodyScroll(noticeModal.value, {
      //   allowTouchMove: () => true,
      // })
    }
  })
  onBeforeUnmount(() => {
    clearAllBodyScrollLocks()
  })

  // 全部清除
  const removeAllNotices = () => {
    noticeDatas.value = []
    NotificationManager.removeAllNotice()
  }
</script>
<style lang="stylus" scoped>

  notice_header_height = 92px
  .notice-modal
    font-style normal
    position absolute
    right 0px
    top 0
    rect(320px, 100%)
    background #ffffff
    box-shadow -10px 0px 36px rgba(16, 22, 82, 0.06)
    transition height 1s
    transition-delay 1s
    overflow hidden
    border-top solid 1px #f0f0f0
    .notice-top
      rect(320px, notice_header_height)
      display flex
      justify-content space-between
      padding 39px 24px 27px
      box-sizing border-box
      .notice-title
        height 26px
        font-weight bolder_font_weight
        font-size 20px
        line-height 26px
        color #000000
      .notice-button
        rect(80px, 32px)
        line-height 32px
        border 1px solid rgba(0, 0, 0, 0.06)
        border-radius 8px
        font-weight default_font_weight
        font-size 14px
        color default_color
        text-align center
        background #ffffff
        cursor pointer
        &:hover
          background rgba(0, 0, 0, 0.06)
        &:active
          background rgba(0, 0, 0, 0.06)
  .notice-tips
    height  "calc(100% - %s)" % notice_header_height
    flex-all-center()
    flex-direction column
  .notice-img
    rect(167.18px, 148px)
    display inline-block
  .no-notice
    rect(280px, 22px)
    font-weight default_font_weight
    font-size 16px
    line-height 21px
    color lighter_shallow_color
    margin 23px auto
    text-align center
  .notice-container
    box-sizing border-box
    padding 0 16px 48px
    height calc(100vh - 168px)
    overflow-y auto

  @import '../styles/h5Adaptive/NotificationCenter.styl'
</style>
